import { WorkspaceSpecificBannerProps } from "@components/banners/workspace-specific-banner/workspace-specific-banner-types";
import { Banner, Text } from "@flat-ui";
import { Box } from "@mui/material";
import { useAppParams } from "@router/router-helper";
import { DateTimeUtils } from "@stellar/utils";
import { useMemo, useState } from "react";

/** Renders a banner that shows only for specific workspaces */
export function WorkspaceSpecificBanner({
  title,
  text,
  variant,
  ids,
  deactivationDate,
}: WorkspaceSpecificBannerProps): JSX.Element | null {
  const { companyId } = useAppParams();

  const [isDismissed, setIsDismissed] = useState<boolean>(false);

  const hasDeactivationDatePassed = useMemo(() => {
    if (!deactivationDate) {
      return false;
    }
    return DateTimeUtils.isDateOverdue(deactivationDate);
  }, [deactivationDate]);

  if (
    !companyId ||
    !ids.includes(companyId) ||
    hasDeactivationDatePassed ||
    isDismissed
  ) {
    return null;
  }

  return (
    <Box data-testid="workspace-specific-banner" component="div">
      <Banner
        title={title}
        variant={variant}
        onClose={() => setIsDismissed(true)}
      >
        <Text variant="bodyM">{text}</Text>
      </Banner>
    </Box>
  );
}
